import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from 'recharts';

interface DataItem {
  culture: string;
  Чуйская: number;
  Баткенская: number;
  "Джалал-Абадская": number;
  Нарынская: number;
  Ошская: number;
  Таласская: number;
  "Ыссык-Кульская": number;
}

const data: DataItem[] = [
  {
    culture: "Виноград",
    Чуйская: 245,
    Баткенская: 1272,
    "Джалал-Абадская": 599,
    Нарынская: 0,
    Ошская: 2345,
    Таласская: 15,
    "Ыссык-Кульская": 0,
  },
];

const GrapeChart: React.FC = () => {
  return (
    // <>
    //   <h2>Данные по реализации Винограда (тонн)</h2>
      <ResponsiveContainer width="50%" height={400}>
        <BarChart data={data} margin={{ top: 20, right: 10, left: 10, bottom: 5 }}>
          <XAxis dataKey="culture" padding={{ left: 0, right: 0 }} />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="Чуйская" fill="#8884d8" />
          <Bar dataKey="Баткенская" fill="#82ca9d" />
          <Bar dataKey="Джалал-Абадская" fill="#ffc658" />
          <Bar dataKey="Нарынская" fill="#d88484" />
          <Bar dataKey="Ошская" fill="#84d8a4" />
          <Bar dataKey="Таласская" fill="#d884d8" />
          <Bar dataKey="Ыссык-Кульская" fill="#d8d884" />
        </BarChart>
      </ResponsiveContainer>
    // </>
  );
};

export default GrapeChart;
